import { ChartDerivedMeasure, ChartPlugin } from '../_types'

const commandDerivedMeasure: ChartDerivedMeasure<'manual' | 'automatic' | 'local' | 'sectioned' | 'command'> = {
  slug: 'command',
  representation: 'time-bar',
  derivationFn: measuresData => {
    if (measuresData.manual) {
      return 0
    }
    if (measuresData.automatic) {
      return 1
    }
    if (measuresData.local) {
      return 2
    }
    if (measuresData.sectioned) {
      return 3
    }
    return null
  },
}

const commandPlugin: ChartPlugin = {
  derivedMeasures: [commandDerivedMeasure],
  measures: [
    {
      slug: 'manual',
      id: 'BS_MAN',
      representation: null,
    },
    {
      slug: 'automatic',
      id: 'BS_AUTO',
      representation: null,
    },
    {
      slug: 'local',
      id: 'BS_LOC',
      representation: null,
    },
    {
      slug: 'sectioned',
      id: 'BS_MAINT',
      representation: null,
    },
  ],
}

export default commandPlugin
